/**
 * 店舗在庫ボタン
 */
export default class StockButton extends HTMLElement {
  constructor() {
    super();
    this.favorited = false;
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `<style>
        button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          outline: none;
          padding: 3px;
          appearance: none;
          box-sizing: border-box;
        }
        button:hover svg {
          opacity: .8;
          transform: scale(1.1);
        }
        button.-is-checked svg {
          color: #e33223;
          animation: heartAnime 500ms;
        }
        button.-type-circle {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          border: 1px solid var(--unico-color-grey03);
          border-radius: 50%;
          background: #fff;
          flex-shrink: 0;
        }
        button svg {
          vertical-align: bottom;
          transition: all .15s ease-in-out 0s;
        }
      </style>
      <button aria-label="店舗在庫・展示店舗を確認する" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22.31" viewBox="0 0 48 48.687"><g transform="translate(0 0)"><path d="M47.986,20.81a1.644,1.644,0,0,0-.6-1.452L25.064,1.164a1.59,1.59,0,0,0-.277-.19c-.023-.01-.045-.019-.066-.03a1.618,1.618,0,0,0-.256-.1L24.346.819A1.816,1.816,0,0,0,24.158.78L24,.782l-.156,0A1.23,1.23,0,0,0,23.7.808l-.154.031a1.379,1.379,0,0,0-.265.1l-.071.032a1.687,1.687,0,0,0-.269.182L.613,19.356a1.648,1.648,0,0,0-.6,1.454L0,47.038a1.618,1.618,0,0,0,.428,1.094l.055.067c.022.018.041.033.059.05a1.629,1.629,0,0,0,1.1.437H15.306a1.648,1.648,0,0,0,1.647-1.6V33.782H31.046V47.038a1.618,1.618,0,0,0,.429,1.094l.055.067c.022.018.041.033.059.05a1.625,1.625,0,0,0,1.1.437H46.353A1.648,1.648,0,0,0,48,47.09ZM44.707,45.4H34.338V32.089a1.648,1.648,0,0,0-1.647-1.6H15.306a1.632,1.632,0,0,0-1.558,1.155,1.61,1.61,0,0,0-.088.49V45.4H3.291V21.418L24,4.541,44.708,21.419Z" fill="#333"/><path d="M23.475,0Z" fill="#333"/></g></svg>
      </button>`;
  }

  connectedCallback() {
    const button = this.shadowRoot.querySelector('button');
    button.addEventListener('click', () => {
      if (button.classList.contains('-is-checked')) {
        button.classList.remove('-is-checked');
      } else {
        button.classList.add('-is-checked');
      }
    });

    const type = this.getAttribute('type');
    if (type) {
      button.classList.add(`-type-${type}`);
    }
  }
}
